export default __webpack_public_path__ + "static/media/cpd.8f941d29.jpg";